import React from "react";

interface ColorDisplayProps {
  color: string;
}

const ColorDisplay: React.FC<ColorDisplayProps> = ({ color }) => {
  if (!color) {
    return <span>-</span>;
  }

  return (
    <div
      style={{
        width: "20px",
        height: "20px",
        backgroundColor: color,
        border: "1px solid #ccc",
        borderRadius: "3px",
        display: "inline-block",
        verticalAlign: "middle",
      }}
      title={color} // Mostrar el código hexadecimal en el tooltip
    />
  );
};

export default ColorDisplay;
